/**
 * Athlete Filter Functionality
 * Shredding Sassy - Action Sports Brand
 *
 * Vanilla JS filter for athlete cards by discipline
 * - Reads data-discipline attribute on cards
 * - Shows/hides based on active filter button
 * - Updates URL params for shareable filtered views
 */

(function() {
  'use strict';

  const SELECTORS = {
    filterNav: '.athlete-filter',
    filterBtn: '.athlete-filter__btn',
    grid: '.athlete-grid',
    card: '.athlete-card',
    emptyMessage: '.athlete-grid__empty'
  };

  const CLASSES = {
    active: 'is-active'
  };

  const PARAM_KEY = 'discipline';

  /**
   * Initialize the athlete filter
   */
  function init() {
    const filterNav = document.querySelector(SELECTORS.filterNav);
    if (!filterNav) return;

    const buttons = filterNav.querySelectorAll(SELECTORS.filterBtn);
    const grid = document.querySelector(SELECTORS.grid);
    const cards = grid ? grid.querySelectorAll(SELECTORS.card) : [];
    const emptyMessage = document.querySelector(SELECTORS.emptyMessage);

    if (buttons.length === 0 || cards.length === 0) return;

    // Check URL for initial filter
    const urlParams = new URLSearchParams(window.location.search);
    const initialFilter = urlParams.get(PARAM_KEY) || 'all';

    // Set initial state
    setActiveFilter(buttons, initialFilter);
    filterCards(cards, initialFilter, emptyMessage);

    // Add click handlers
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter;

        setActiveFilter(buttons, filter);
        filterCards(cards, filter, emptyMessage);
        updateURL(filter);
      });
    });

    // Handle browser back/forward
    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(window.location.search);
      const filter = params.get(PARAM_KEY) || 'all';

      setActiveFilter(buttons, filter);
      filterCards(cards, filter, emptyMessage);
    });
  }

  /**
   * Set the active filter button
   * @param {NodeList} buttons - Filter buttons
   * @param {string} filter - Active filter value
   */
  function setActiveFilter(buttons, filter) {
    buttons.forEach(btn => {
      const isActive = btn.dataset.filter === filter;
      btn.classList.toggle(CLASSES.active, isActive);
      btn.setAttribute('aria-pressed', isActive);
    });
  }

  /**
   * Filter athlete cards by discipline
   * @param {NodeList} cards - Athlete cards
   * @param {string} filter - Filter value ('all' or discipline name)
   * @param {Element} emptyMessage - Empty state message element
   */
  function filterCards(cards, filter, emptyMessage) {
    let visibleCount = 0;

    cards.forEach(card => {
      const discipline = card.dataset.discipline;
      const shouldShow = filter === 'all' || discipline === filter;

      card.hidden = !shouldShow;

      if (shouldShow) {
        visibleCount++;
        // Re-trigger animation
        card.style.animation = 'none';
        card.offsetHeight; // Force reflow
        card.style.animation = '';
      }
    });

    // Show/hide empty message
    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  }

  /**
   * Update URL with filter parameter
   * @param {string} filter - Filter value
   */
  function updateURL(filter) {
    const url = new URL(window.location.href);

    if (filter === 'all') {
      url.searchParams.delete(PARAM_KEY);
    } else {
      url.searchParams.set(PARAM_KEY, filter);
    }

    window.history.pushState({}, '', url);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
